import { FormItemProps } from "@app/components/forms/types/props";
import { CheckboxGroupSchema } from "@app/components/forms/types/schema";
import {
  Checkbox,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@shortsworks/ui";
import { useEffect } from "react";

export const FormCheckboxGroup = ({
  form,
  schema,
  ...rest
}: FormItemProps<CheckboxGroupSchema>) => {
  useEffect(() => {
    if (
      form.getValues(schema.id) === undefined ||
      form.getValues(schema.id) === ""
    ) {
      form.setValue(schema.id, []);
    }
  }, []);

  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={() => (
        <FormItem>
          <div className="mb-4">
            <FormLabel className="text-base">
              {typeof schema.label === "function"
                ? schema.label(form.getValues())
                : schema.label}
            </FormLabel>
            {schema.description && (
              <FormDescription>
                {typeof schema.description === "function"
                  ? schema.description(form.getValues())
                  : schema.description}
              </FormDescription>
            )}
          </div>
          {schema.options.map((item, index) => (
            <FormField
              key={`${schema.id}-${item.value}-${index}`}
              control={form.control}
              name={schema.id}
              render={({ field }: any) => {
                return (
                  <FormItem
                    key={item.value}
                    className="flex flex-row items-start space-x-3 space-y-0"
                  >
                    <FormControl>
                      <Checkbox
                        className="mt-0.5"
                        checked={field.value?.includes(item.value)}
                        onCheckedChange={(checked: boolean) => {
                          return checked
                            ? field.onChange([...field.value, item.value])
                            : field.onChange(
                                field.value?.filter(
                                  (value: any) => value !== item.value,
                                ),
                              );
                        }}
                      />
                    </FormControl>
                    <div className="space-y-1 leading-none">
                      <FormLabel>
                        {typeof item.label === "function"
                          ? item.label(form.getValues())
                          : item.label}
                      </FormLabel>
                      {item.description && (
                        <FormDescription>
                          {typeof item.description === "function"
                            ? item.description(form.getValues())
                            : item.description}
                        </FormDescription>
                      )}
                    </div>
                  </FormItem>
                );
              }}
            />
          ))}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
